import '../lib/typedef';
import client from '../lib/http-client';

const endpoint = '/billings';

export default {
	/**
	 * Get Histories
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.category] Category Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getList(params, cb, errorCb) {
		const url = endpoint;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get All Billings (admin only)
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.category] Category Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getAll(params, cb, errorCb) {
		const url = `${endpoint}/all`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Export Billings (admin only)
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.category] Category Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	exportBillings(params, cb, errorCb) {
		const url = `${endpoint}/export-billings`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get History by ID
	 *
	 * @param {String|Int} id History ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	get(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Outstandings Total
	 *
	 * @param {String|Int} id History ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getOutstandings(cb, errorCb) {
		const url = `${endpoint}/outstandings`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
		* Get Outstandings Count
		*
		* @param {String|Int} id History ID
		* @param {requestCallback} cb
		* @param {errorCallback} errorCb
	*/
	getOutstandingsCount(cb, errorCb) {
		const url = `${endpoint}/outstandings-count`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Due Billings Count
	getDueBillingsCount(cb, errorCb) {
		const url = `${endpoint}/due-count`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get All Outstandings Total
	 *
	 * @param {String|Int} id History ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getAllOutstandings(cb, errorCb) {
		const url = `${endpoint}/outstandings/all`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Total
	 *
	 * @param  {Object} params
	 * @param  {String} params.since
	 * @param  {String} params.until
	 * @param  {String} params.status
	 * @param  {String} params.courier
	 * @param  {requestCallback} cb
	 * @param  {errorCallback} errorCb
	 */
	getTotal(params, cb, errorCb) {
		const url = `${endpoint}/total`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get All Total
	 *
	 * @param  {Object} params
	 * @param  {String} params.since
	 * @param  {String} params.until
	 * @param  {String} params.status
	 * @param  {String} params.courier
	 * @param  {requestCallback} cb
	 * @param  {errorCallback} errorCb
	 */
	getAllTotal(params, cb, errorCb) {
		const url = `${endpoint}/total/all`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Confirm
	confirm(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/confirm`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Submit Payment Confirmation
	submitPaymentConfirmation(params, cb, errorCb) {
		const url = `${endpoint}/payment-confirmation`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Verify Payment
	verifyPayment(id, cb, errorCb) {
		const url = `${endpoint}/${id}/verify-payment`;
		client.post(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export
	exportDetails(params, cb, errorCb) {
		const url = `${endpoint}/export`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export by Admin
	exportDetailsByAdmin(params, cb, errorCb) {
		const url = `${endpoint}/export/all`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	* Generate Payment Token
	*
	* @param  {Object} params
	* @param  {String} params.since
	* @param  {String} params.until
	* @param  {String} params.status
	* @param  {String} params.courier
	* @param  {requestCallback} cb
	* @param  {errorCallback} errorCb
	*/
	getPaymentToken(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/payment_token`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Payment Token - Billing Group
	getPaymentTokenGroup(params, cb, errorCb) {
		const url = `${endpoint}/payment_token/group`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Billing Status
	getStatus(id, cb, errorCb) {
		const url = `${endpoint}/${id}/status`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Billing Status - Billing Group
	getStatusGroup(id, cb, errorCb) {
		const url = `${endpoint}/${id}/status/group`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Cancel Subscription Billing
	cancelSubscription(id, cb, errorCb) {
		const url = `${endpoint}/${id}/cancel_subscription`;
		client.post(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Billing Status
	generateSubscription(params, cb, errorCb) {
		const url = `${endpoint}/create-subscription-billing`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update Billing Due Date
	updateDueDate(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/due_date`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update Billing Value (Only for type subscription)
	updateValue(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/value`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
